import { Setter } from "./ReactUtils";

export class MutableState<T> {
    private _status: T;
    private _statusSetter: (status: T) => void;

    constructor(state: T, setter: (status: T) => void) {
      this._status = state;
      this._statusSetter = setter;
  }

    get status(): T {
      return this._status;
    }
  
    set status(newStatus: T) {
      this._status = newStatus;
      this._statusSetter(newStatus);
    }

    setState = (newStatus: T) => () => { 
        return this._statusSetter(newStatus) 
    };
    
    static of<T>(state: T, setter: Setter<T>): MutableState<T> {
      return new MutableState<T>(state, setter)
    } 

    static wrap<T>(initialState: [T, (status: T) => void]): MutableState<T> {
      const [state, setter] = initialState;
      return new MutableState<T>(state, setter)
  }
  }
